// extracted by mini-css-extract-plugin
export default {"wikiCard":"cardDetails_wikiCard__2wMEk"};